import { PersonaOption } from '../domain';

export const PERSONA_OPTIONS: PersonaOption[] = [
  {
    id: 'python_expert',
    title: 'Python Expert',
    subtitle: 'Seasoned engineer for Python architecture and code reviews.',
  },
  {
    id: 'docker_expert',
    title: 'Docker Expert',
    subtitle: 'Container specialist for Dockerfiles and deployment tuning.',
  },
];
